export default __webpack_public_path__ + "menu-instagram-icon.c405ac06e327c960cda2dc2ed4b6d408.svg";